module.exports = __webpack_public_path__ + "img/icon-close.3247f3fb.svg";